var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ace-editor-main"},[_c('editor',{ref:"editor",attrs:{"width":"100%","height":"100%","content":_vm.content,"options":{
     enableBasicAutocompletion: true,
     enableSnippets: true,
     enableLiveAutocompletion: true,
     tabSize:2,
     fontSize:15,
     showPrintMargin:false,   //去除编辑器里的竖线
   },"lang":_vm.language},on:{"init":_vm.editorInit},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }